import { combineReducers } from "redux";

import containersReducer from "../reducers/containersReducer";
import itemsReducer from "./itemsReducer";
import configurationReducer from "./configurationsReducer";
import artworkReducer from "./artworkReducer";
import reportsReducer from "./reportsReducer";
import operationsReducer from "./operationsReducer";
import hubspotReducer from "./hubspotReducer";
import adminReducer from "./adminReducer";
import productTrackerReducer from "./productTrackerReducer";
import chinaTrackerReducer from "./chinaTrackerReducer";
import notificationReducer from "./notificationReducer";
import usersReducer from "./userReducer";
import portalReducer from "./portalReducer";
import { deliveryReducer, stockTransferReducer } from "./deliveryReducer";
import persistReducer from "redux-persist/es/persistReducer";
import AsyncStorage from "@react-native-async-storage/async-storage";

// Create a separate persist configuration for the admin reducer only
const persistConfig = {
  key: "admin", // Persist only the admin state
  storage: AsyncStorage,
};

const persistedAdminReducer = persistReducer(persistConfig, adminReducer);

const appReducer = combineReducers({
  configurations: configurationReducer,
  containers: containersReducer,
  items: itemsReducer,
  delivery: deliveryReducer,
  stockTransfer: stockTransferReducer,
  artwork: artworkReducer,
  reports: reportsReducer,
  operations: operationsReducer,
  hubspot: hubspotReducer,
  admin: persistedAdminReducer,
  productTracker: productTrackerReducer,
  chinaTracker: chinaTrackerReducer,
  notification: notificationReducer,
  users: usersReducer,
  portal: portalReducer,
});

//  Reset Redux state on logout
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined; // This resets all slices to their initial state
  }
  return appReducer(state, action);
};
export default rootReducer;
